module.exports = __webpack_public_path__ + "img/t_cfx.e876d1cd.svg";